import React, { useEffect, useState, useMemo } from "react"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import TableContainer from "../../../components/Common/TableContainer"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import DeleteModal from "components/Common/DeleteModal"

import {
  getUsers as onGetUsers,
  addNewUser as onAddNewUser,
  updateUser as onUpdateUser,
  deleteUser as onDeleteUser,
} from "store/contacts/actions"
import { isEmpty } from "lodash"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import Spinners from "components/Common/Spinner"
import { ToastContainer } from "react-toastify"
import { getUsers } from "helpers/fakebackend_helper"
import API_SERVICE from "shared/services/api-services"
import { notification } from "../../../shared/utility/Utility"
import infoIcon from "../../../assets/images/info-icon.png"
const ContactsList = () => {
  //meta title
  document.title = "Inventya"

  const dispatch = useDispatch()
  const [contact, setContact] = useState()
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (contact && contact.name) || "",
      password: (contact && contact.password) || "",
      confirmPassword: (contact && contact.confirmPassword) || "",
      email: (contact && contact.email) || "",
      type: (contact && contact.type) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Your Name"),
      type: Yup.string().required("Please Select User Type"),
      email: Yup.string()
        .matches(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, "Please Enter Valid Email")
        .required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
      confirmPassword: Yup.string().required("Please Confirm Your Password"),
    }),
    onSubmit: async values => {
      if (isEdit) {
        const updateUser = {
          id: contact.id,
          name: values.name,
          designation: values.designation,
          tags: values.tags,
          email: values.email,
          projects: values.projects,
        }
        // update user
        dispatch(onUpdateUser(updateUser))
        setIsEdit(false)
        validation.resetForm()
      } else {
        try {
          if (values.password != values.confirmPassword) {
            notification("error", "Entered passwords do not match")
            return
          }
          const params = {
            name: values["name"],
            email: values["email"],
            password: values["password"],
            type: values["type"],
          }
          const {
            data: { data },
          } = await API_SERVICE.addUser(params)
          validation.resetForm()
          notification("success", "User Added")
        } catch (error) {
          notification("error", error.response.statusText)
        }
      }
      toggle()
      getUsers()
    },
  })

  const ContactsProperties = createSelector(
    state => state.contacts,
    Contacts => ({
      users: Contacts.users,
      loading: Contacts.loading,
    })
  )

  const { users, loading } = useSelector(ContactsProperties)
  const [user, setUser] = useState([])
  const [modal, setModal] = useState(false)
  const [modalActive, setModalActive] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isLoading, setLoading] = useState(loading)

  const getUsers = async () => {
    try {
      setLoading(true)
      const {
        data: { data },
      } = await API_SERVICE.getUserList()
      setUser(data.results)
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    } finally{
      setLoading(false)
    }
  }
  const toggleUserStatus = async () => {
    try {
      const {
        data: { data },
      } = await API_SERVICE.changeUserStatus(id.id, { isActive: !id.isActive })
      getUsers()
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }
  useEffect(() => {
    if (users && !users.length) {
      setIsEdit(false)
    }
  }, [dispatch, users])
  useEffect(() => {
    getUsers()
  }, [])
  useEffect(() => {
    setContact(users)
    setIsEdit(false)
  }, [users])

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users)
      setIsEdit(false)
    }
  }, [users])

  const toggle = () => {
    setModal(!modal)
  }
  const toggleActive = () => {
    setModalActive(!modalActive)
  }

  const handleUserClick = arg => {
    const user = arg

    setContact({
      id: user.id,
      name: user.name,
      designation: user.designation,
      email: user.email,
      tags: user.tags,
      projects: user.projects,
    })
    setIsEdit(true)

    toggle()
  }
  const [id, setId] = useState()
  //delete customer
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = users => {
    setContact(users.id)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (contact && contact.id) {
      dispatch(onDeleteUser(contact.id))
    }
    setDeleteModal(false)
  }

  const handleUserClicks = () => {
    setContact("")
    setIsEdit(false)
    toggle()
  }

  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cell => {
          return (
            <>
              <h5 className="font-size-14 mb-1">
                <Link to="#" className="text-dark">
                  {cell.getValue()}
                </Link>
              </h5>
            </>
          )
        },
      },
      {
        header: "Email",
        accessorKey: "email",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Type",
        accessorKey: "type",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Status",
        accessorKey: "isActive",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cell => {
          return cell.getValue() === true ? (
            <div
              style={{ backgroundColor: "#34C38F", color: "white" }}
              className="badge badge-soft-primary font-size-13 m-1 p-1"
              onClick={() => {
                setModalActive(true)
                setId({ id: cell.row.original.id, isActive: cell.getValue() })
              }}
            >
              Active
            </div>
          ) : (
            <div
              style={{ backgroundColor: "#F46A6A", color: "white" }}
              className="badge badge-soft-primary font-size-13 m-1 p-1"
              onClick={() => {
                setModalActive(true)
                setId({ id: cell.row.original.id, isActive: cell.getValue() })
              }}
            >
              Inactive
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Contacts" breadcrumbItem="User List" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody
                  style={{
                    minHeight: "calc(100vh - 230px)",
                  }}
                >
                  {isLoading ? (
                    <Spinners />
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={user || []}
                      isGlobalFilter={true}
                      isPagination={true}
                      SearchPlaceholder="Search..."
                      isCustomPageSize={true}
                      isAddButton={true}
                      handleUserClick={handleUserClicks}
                      buttonClass=" theme-btn"
                      buttonName="Add New User"
                      tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      pagination="pagination"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>

            <Modal centered={true} isOpen={modal} toggle={toggle}>
              <ModalHeader toggle={toggle} tag="h4">
                {!!isEdit ? "Edit User" : "Add User"}
              </ModalHeader>
              <ModalBody>
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Row>
                    <Col xs={12}>
                      <div className="mb-3">
                        <Label className="form-label">Name</Label>
                        <Input
                          name="name"
                          type="text"
                          placeholder="Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.name || ""}
                          invalid={
                            validation.touched.name && validation.errors.name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.name && validation.errors.name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.name}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          label="Email"
                          type="email"
                          placeholder="Email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          label="Password"
                          type="text"
                          placeholder="Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                              ? true
                              : false
                          }
                        />
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Confirm Password</Label>
                        <Input
                          name="confirmPassword"
                          label="Confirm Password"
                          type="text"
                          placeholder="Confirm Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.confirmPassword || ""}
                          invalid={
                            validation.touched.confirmPassword &&
                            validation.errors.confirmPassword
                              ? true
                              : false
                          }
                        />
                        {validation.touched.projects &&
                        validation.errors.projects ? (
                          <FormFeedback type="invalid">
                            {validation.errors.confirmPassword}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">User Type</Label>
                        <Input
                          type="select"
                          name="type"
                          className="form-select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.type || ""}
                          invalid={
                            validation.touched.type && validation.errors.type
                              ? true
                              : false
                          }
                        >
                          <option>User Type</option>
                          <option>Admin</option>
                          <option>Editor</option>
                        </Input>
                        {validation.touched.type && validation.errors.type ? (
                          <FormFeedback type="invalid">
                            {validation.errors.type}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="text-end">
                        <button
                          type="submit"
                          className="btn btn-success save-user"
                        >
                          Save
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </ModalBody>
            </Modal>
            <Modal centered={true} isOpen={modalActive} toggle={toggleActive}>
              <ModalBody className="d-flex justify-content-center align-items-center flex-column">
                <img src={infoIcon} className="text-center" />
                <p className="text-center fw-bold f-13">
                  {`Are you sure to ${
                    id?.isActive ? "deactivate" : "activate"
                  } this user?`}
                </p>
                <div
                  className="text-end d-flex justify-content-center align-items-center gap-3"
                  onClick={toggleActive}
                >
                  <button className="btn theme-btn-outline save-user mr-2">
                    No
                  </button>
                  <button
                    type="submit"
                    className="btn theme-btn save-user"
                    onClick={() => toggleUserStatus()}
                  >
                    Yes
                  </button>
                </div>
              </ModalBody>
            </Modal>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  )
}

export default withRouter(ContactsList)
